import React, { Component } from 'react'
import { translate } from '../../utils/useful'
import IntractionActionsList from '../../components/IntractionActionsList'
import StagesManager from '../../components/StagesManager'
import FixedView from '../../components/FixedView'

export default class NotebookExtentions extends Component {

    state = {}

    functionsHandler = (type, name, data) => {
        this.props.functionsHandler(type, name, data)
        this.fiexView?.hideView()
    }

    changePageSubMenu = (title) => {
        this.stageManager.changeStage(title)
    }

    lastPage = () => {
        this.stageManager.lastStage()
    }

    render() {
        return (
            <>
                <button className='mrd-2 flexcc dark-blur-hover px-2 py-1 br-5' ref={el => this.extentions = el} onClick={() => { this.extentionsView.showView() }}>
                    <p className='white font-size-13' style={{ color: this.props.colors?.textColor }}>{translate('notebook.Extentions')}</p>
                </button>
                <FixedView width={this.props.width} zIndex={10} ref={(el) => (this.extentionsView = el)} nodeRef={this.extentions} xOffset={this.props.language == "fa" ? 175 : -10} bottomOffset={0} topOffset={0} maxWidth={260}    >
                    <div className="bg-white br-10 p-1 shadow-3">
                        <StagesManager ref={(el) => (this.stageManager = el)} height={"100%"} fast={true}  >
                            <div width={this.props.width} isLoading={this.props.isLoading} stage={0} stageName={"extention"} className=" p-1 sc-gray2" style={{ maxHeight: "350px", overflowY: "auto" }}   >
                                <div className="">
                                    <IntractionActionsList language={this.props.language} onClick={() => this.changePageSubMenu("Add-ons")} data={{ title: "{{lang}}notebook.Add-ons", sub: true, icon: "/assets/icons/note/extentions/add-ons.svg" }} />
                                    <IntractionActionsList language={this.props.language} data={{ title: "{{lang}}notebook.Yonnect World", icon: "/assets/icons/note/extentions/yonnect.svg" }} />
                                </div>
                            </div>
                            <div width={this.props.width} isLoading={this.props.isLoading} stage={1} stageName={"Add-ons"} className=" p-1 sc-gray2" style={{ maxHeight: "350px", overflowY: "auto" }}  >
                                <div className="">
                                    <div className="pb-2">
                                        <button className="flexc w-100 hover-gray p-2 br-10" onClick={this.lastPage}  >
                                            <img width={18} src="/assets/icons/arrow-left-gray.svg" className="rtl-button" />
                                            <p className="font-size-13 weight-500 mld-3 main-c3 text-start">   {translate("notebook.Add-ons")}  </p>
                                        </button>
                                    </div>
                                    <div className="py-2" style={{ borderTop: "1px solid #eee" }}   >
                                        <IntractionActionsList language={this.props.language} onClick={() => this.changePageSubMenu("Get add-ons")} data={{ title: "{{lang}}notebook.Get add-ons" }} />
                                        <IntractionActionsList language={this.props.language} onClick={() => this.changePageSubMenu("Manage add-ons")} data={{ title: "{{lang}}notebook.Manage add-ons" }} />
                                    </div>
                                    <div className="pt-2" style={{ borderTop: "1px solid #eee" }}   >
                                        <IntractionActionsList language={this.props.language} onClick={() => this.changePageSubMenu("View document add-ons")} data={{ title: "{{lang}}notebook.View document add-ons" }} />
                                    </div>
                                </div>
                            </div>
                        </StagesManager>
                    </div>
                </FixedView>
            </>
        )
    }
}
